import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function BoltIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.953 4.28919C11.9131 4.20237 11.8491 4.12882 11.7686 4.07724C11.6882 4.02567 11.5946 3.99824 11.499 3.99819H6.14003L6.98403 0.619195C7.0108 0.51014 7.00008 0.395249 6.9536 0.293029C6.90712 0.190809 6.82758 0.107212 6.7278 0.0557039C6.62801 0.00419593 6.5138 -0.0122238 6.40355 0.00908957C6.2933 0.030403 6.19343 0.0882087 6.12003 0.173195L0.120034 7.17319C0.0579605 7.24577 0.0179681 7.3346 0.00478642 7.42918C-0.00839528 7.52376 0.00578511 7.62014 0.0456506 7.70692C0.0855161 7.7937 0.149399 7.86725 0.229744 7.91886C0.31009 7.97048 0.403537 7.99801 0.499034 7.99819H5.85803L5.01403 11.3772C4.98687 11.4864 4.99737 11.6017 5.04383 11.7042C5.09029 11.8067 5.16999 11.8906 5.27003 11.9422C5.34067 11.9792 5.41928 11.9984 5.49903 11.9982C5.57109 11.9981 5.64226 11.9823 5.70767 11.9521C5.77309 11.9219 5.8312 11.8779 5.87803 11.8232L11.878 4.82319C11.9403 4.75066 11.9804 4.66181 11.9937 4.56717C12.007 4.47253 11.9929 4.37606 11.953 4.28919Z" />
      </svg>
    </Icon>
  );
}
